<div class="modal-header">
  <h4 class="modal-title header-5">Filter By</h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
      alt="Close"
    />
  </button>
</div>

<div class="modal-body mt-2">
  <div class="d-flex filter-wrapper" [class.tcg-filter-mode]="mode === 'tcg'">
    <!-- Left Sidebar -->
    <div class="filter-sidebar">
      <div
        *ngFor="let item of sidebarItems; let i = index"
        class="filter-nav-item"
        [class.active]="isSectionActive(i)"
        [class.completed]="isSectionCompleted(i)"
        [class.disabled]="mode !== 'tcg' && !isSectionEnabled(i)"
        [class.nav-readonly]="mode === 'tcg'"
        (click)="onSidebarNavClick(i)"
      >
        {{ item.label }}
      </div>
    </div>

    <!-- Right Content Area - Dynamic Form -->
    <div class="filter-content">
      <div *ngIf="mode === 'prompt' && isLoadingTree" class="filter-tree-loading">
        <div class="filter-spinner"></div>
        <span>Loading services...</span>
      </div>
      <div *ngIf="mode === 'prompt' && isLoadingPrompts" class="filter-tree-loading">
        <div class="filter-spinner"></div>
        <span>Loading prompts...</span>
      </div>
      <app-dynamic-form
        *ngIf="mode === 'tcg' || !isLoadingTree"
        [form]="dynamicForm"
        [formFields]="formFields"
        (modelChange)="onFieldChange($event)"
      ></app-dynamic-form>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-between w-100 align-items-center">
    <div type="button" class="btn btn-accello-tertiary reset-all-btn" (click)="resetAll()" (keydown.enter)="resetAll()">
      Reset all
    </div>
    <button
      type="button"
      class="btn btn-accello-primary-light mx-2 btn-spin m-auto me-0"
      [disabled]="mode === 'tcg' && !tcgApplyEnabled"
      (click)="applyFilters()"
    >
      <span>Apply</span>
    </button>
  </div>
</div>
